/**
 * Phase 2A — the dashboard can ship standalone with no backend. The mock layer
 * drives the UI through an in-memory LOTO timeline.
 *
 * OPT-IN ONLY: `VITE_MOCK_MODE=true` at build time, or `mockMode: "true"` in the
 * runtime config the `apps/web` container writes to `/config.js`. Anything else,
 * including a forgotten variable, gets the real ApiClient + WebSocket gateway.
 *
 * The mock invents verdicts, sessions and trainees. A build that fell back to it
 * (the old `!== 'false'` default) would show a trainer a floor that isn't there,
 * with a DEMO badge as the only tell. A missing variable should break the page,
 * not quietly replace the data. The resolution order lives in `runtimeConfig.ts`.
 */
import { mockModeRequested } from './runtimeConfig';

export const MOCK_MODE: boolean = mockModeRequested;
